module.exports = __webpack_public_path__ + "img/mainhomephn1.51521712.png";